/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasty_Tense_Leopard_NurtureInputs */

const es_tasty_tense_leopard_nurture = /** @type {(inputs: Tasty_Tense_Leopard_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa tus credenciales para entrar en Zarpar.`)
};

const gl_tasty_tense_leopard_nurture = /** @type {(inputs: Tasty_Tense_Leopard_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce as túas credenciais para entrar en Zarpar.`)
};

const en_tasty_tense_leopard_nurture = /** @type {(inputs: Tasty_Tense_Leopard_NurtureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your credentials to log in to Zarpar.`)
};

/**
* | output |
* | --- |
* | "Enter your credentials to log in to Zarpar." |
*
* @param {Tasty_Tense_Leopard_NurtureInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const tasty_tense_leopard_nurture = /** @type {((inputs?: Tasty_Tense_Leopard_NurtureInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasty_Tense_Leopard_NurtureInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_tasty_tense_leopard_nurture(inputs)
	if (locale === "en") return en_tasty_tense_leopard_nurture(inputs)
	return es_tasty_tense_leopard_nurture(inputs)
});